<div class="fixed-page" [ngClass]="{ 'keyboard-opened' : keyboardOpen}"  [ngClass] ="checkStorageService.isIos()">

    <div class="header-check-page">
        <div class="header-section" [ngClass]="mode === 'view' ? 'header-section-view' : ''">
            <h1 class="modal-title" id="hygieneCheckModalLabel">{{ 'CHECK.NEW_HYGIENE_CHECK_TITLE' | translate }}</h1>
        </div>

        <div class="hygiene-check-info" [ngClass]="mode === 'view' ? 'hygiene-check-info-view' : ''">
            <label class="right-line">{{ institutionName }}</label>
            <label class="right-line ward-name">{{ wardName }}</label>
            <label> {{ departmentName | translate }} </label>

            <div class="edited-box ml-auto" *ngIf="mode === 'view' && (editorData && editorData.editedBy != -1) && !isReportCheck">
              <img class="mr-4 image-edit" src="assets/icons/info-blue.svg"/>
              <span class="mr-1 edit-text">{{ 'CHECK.INSPECTION_EDITED_BY' | translate }}</span>
              <span class="edit-text bold">{{ editorData?.editedByUsername }}.</span>
            </div>
        </div>

        <div class="hygiene-check-tabs">
            <button class="tab" [ngClass]=" { 'active' : hygieneTabSelected === 0 } " (click)="hygieneTabSelected = 0">
                <img class="mr-sm-0 mr-md-2"
                    [src]=" hygieneTabSelected === 0 ? 'assets/icons/checkListSelectedOutlined.svg' : 'assets/icons/checkListOutlined.svg'" />
                <span class="d-none d-md-block">{{ 'CHECK.CHECK_LIST_TAB' | translate }}</span>
            </button>

            <button class="tab" [ngClass]=" { 'active' : hygieneTabSelected === 1, 'disabled': mode != 'view' || (mode == 'view' && stationAudits.length == 0) } " (click)="onClickStationAuditTab()">
                <img class="icon-disabled"
                    [src]=" hygieneTabSelected === 1 ? 'assets/icons/cameraSelectedOutlined.svg' : 'assets/icons/cameraOutlined.svg'" />
                <span class="d-none d-md-block">{{ 'CHECK.AUDIT_TAB' | translate }}</span>

                <lib-popover *ngIf="device === 'desktop' && mode !== 'view'" icon="infoOutlinedDisabled" message="{{'CHECK.AUDIT_TAB_MESSAGE' | translate}}"></lib-popover>
                <lib-popover *ngIf="device === 'desktop' && mode === 'view' && stationAudits.length == 0" icon="infoOutlinedDisabled" message="{{'CHECK.AUDIT_TAB_VIEW_MESSAGE' | translate}}"></lib-popover>
            </button>

            <button class="tab" [ngClass]=" { 'active' : hygieneTabSelected === 2 } " (click)="hygieneTabSelected = 2">
                <img
                    [src]=" hygieneTabSelected === 2 ? 'assets/icons/notesSelectedOutlined.svg' : 'assets/icons/notesOutlined.svg'" />
                <span class="d-none d-md-block">{{ 'CHECK.NOTES_TAB' | translate }}</span>
            </button>

            <button class="tab" [ngClass]=" { 'active' : hygieneTabSelected === 3 } " (click)="getPreviousCheck()">
                <img
                    [src]=" hygieneTabSelected === 3 ? 'assets/icons/historyOutlinedSelected.svg' : 'assets/icons/historyOutlined.svg'" />
                <span class="d-none d-md-block">{{ 'CHECK.PREVIOUS_HYGIENE_CHECK' | translate }}</span>
            </button>
            <span class="bottom-line"></span>
        </div>
    </div>

    <div class="body-page" [ngClass]="{'hideButtons': !showButtons, 'previousTab': hygieneTabSelected === 3}">
        <!-- Tab 1 -->
        <div *ngIf="hygieneTabSelected === 0 && userQuestions && userQuestions.length" class="tab-container">
            <lib-hygieneplan-tab [questions]="userQuestions" [checkId]="id" [editable]="mode === 'view' ? false : true"></lib-hygieneplan-tab>
        </div>
        <!-- End Tab 1 -->

        <!-- Tab 2 -->
        <div *ngIf="hygieneTabSelected === 1" class="tab-container tab-audit-container">
            <lib-gallery-station-audit-tab
                [checkId]="checkId"
                [stationAudits]="stationAudits"
                (updateImageEvent)="updateStationAudit()"
                (emitClickTextarea)="keyboardEvent($event)"
                [isFirstSAMessageShown]="isFirstSAMessageShown"
                [quickComments]="quickComments"
                [editable]="mode === 'view' ? false : true"
                (emitClearInterval)="resetInterval($event)"></lib-gallery-station-audit-tab>
        </div>
        <!-- End Tab 2-->

        <!-- Tab 3 -->
        <div *ngIf="hygieneTabSelected === 2" class="tab-container">
            <lib-notes-tab [userQuestionnaire]="userQuestionnaire" [editable]="mode === 'view' ? false : true"></lib-notes-tab>
        </div>
        <!-- End Tab 3 -->

        <!-- Tab 4 -->
        <div *ngIf="hygieneTabSelected === 3" class="tab-container previous-check-tab">
            <lib-previous-check-tab *ngIf="previousCheck" [previousCheck]="previousCheck"></lib-previous-check-tab>
        </div>
         <!-- End Tab 4 -->
    </div>

    <div class="footer-page" *ngIf="showButtons && mode !== 'view'">

        <button type="button" *ngIf="showButtons" class="btn btn-cancel" (click)="closePage()">{{ 'CHECK.BACK_OVERVIEW' | translate }}</button>
        <!--<button type="button" *ngIf="showButtons" class="btn btn-confirm btn-confirm-custom" (click)="saveChanges()">Audit beenden</button>-->
        <button type="button" *ngIf="showButtons" class="btn btn-confirm btn-confirm-custom" data-toggle="modal" data-target="#completeCheckModal"> {{ 'CHECK.FINALIZE_AUDIT' | translate }} </button>
    </div>

    <div class="footer-page" *ngIf="showButtons && mode === 'view'">
      <button type="button" *ngIf="showButtons" class="btn btn-cancel" (click)="closeViewPage()">{{ 'CHECK.BACK_OVERVIEW' | translate }}</button>
    </div>

    <!-- Modal -->
    <lib-complete-check-modal (completeEmit)="saveChanges($event)"></lib-complete-check-modal>
    <lib-inactivity-check-modal #inactivityModal (continueEditingEmit)="continueEditing()" (returnOverviewEmit)="returnOverview()"></lib-inactivity-check-modal>
</div>

<!--<lib-inspection-offcanvas></lib-inspection-offcanvas>-->
